import { RemoteUnlinkCourseFromEntity } from 'data/usecases';
import { makeApiUrlEntitiesCourses } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUnlinkCourseFromEntity =
  (): RemoteUnlinkCourseFromEntity => {
    return new RemoteUnlinkCourseFromEntity(
      makeApiUrlEntitiesCourses(),
      makeAxiosHttpClient(),
    );
  };
